const conditions = {
	8: {
		abbr: 'GM',
		background: 'black',
		name: 'Gem Mint'
	},
	7: {
		abbr: 'M',
		background: 'green',
		name: 'Mint'
	},
	6: {
		abbr: 'NM',
		background: 'green',
		lighten: 0.1,
		name: 'Near Mint'
	},
	5: {
		abbr: 'EX',
		background: 'gold2',
		name: 'Excellent'
	},
	4: {
		abbr: 'GD',
		background: 'orange',
		name: 'Good'
	},
	3: {
		abbr: 'LP',
		background: 'red',
		lighten: 0.2,
		name: 'Lightly Played'
	},
	2: {
		abbr: 'PL',
		background: 'red',
		lighten: 0.1,
		name: 'Played'
	},
	1: {
		abbr: 'P',
		background: 'red',
		name: 'Poor'
	}
}

export default conditions
